import { companyRequest } from './api';

export interface ProcessingSettings {
  mode: 'global' | 'eu';
  revision: number;
  organizationId: string;
}

export const fetchProcessingSettings = (organizationId: string) =>
  companyRequest<{ settings: ProcessingSettings }>(
    `/api/v1/company/processing?organization_id=${encodeURIComponent(organizationId)}`,
  );

export const saveProcessingSettings = (
  organizationId: string,
  settings: Pick<ProcessingSettings, 'mode' | 'revision'>,
) =>
  companyRequest<{ settings: ProcessingSettings }>('/api/v1/company/processing', 'PATCH', {
    organizationId,
    ...settings,
  });
